import deleteWithSwal from '@/common/delete_with_swal'
import setupActionCable from './action_cable'

function initOnce() {
  deleteWithSwal()
  setupActionCable()
}

if (document.readyState !== 'loading') {
  initOnce()
} else {
  document.addEventListener('DOMContentLoaded', initOnce)
}
